export function resizeSelect(sel: HTMLSelectElement, fontSize = 0.875): void {
  if (!sel) return

  const tempOption = document.createElement('option')
  tempOption.textContent = sel.selectedOptions[0].textContent

  const tempSelect = document.createElement('select')
  tempSelect.style.visibility = 'hidden'
  tempSelect.style.position = 'fixed'
  tempSelect.style.width = 'auto'
  tempSelect.style.fontSize = `${fontSize}rem`
  tempSelect.appendChild(tempOption)

  sel.after(tempSelect)
  sel.style.width = `${+tempSelect.clientWidth + 30}px`
  tempSelect.remove()
}
